import { backendClient } from '@/api/backendClient';
import type {
  ApiAccessManagementRequest,
  ApiLifeCycleRequest,
  ApiUpdateRequest,
  ApiVisibilityRequest,
  ScopeCreationRequest,
  ScopeDeletionRequest,
} from '@/openapi/schema';

export function updateAccessManagement(apiSlug: string, request: ApiAccessManagementRequest) {
  return backendClient.PUT('/apis/{apiSlug}/access-management', {
    params: {
      path: {
        apiSlug,
      },
    },
    body: request,
  });
}

export function updateVisibilityConfig(apiSlug: string, request: ApiVisibilityRequest) {
  return backendClient.PUT('/apis/{apiSlug}/visibility', {
    params: {
      path: {
        apiSlug,
      },
    },
    body: request,
  });
}

export function updateApiLifeCycle(apiSlug: string, request: ApiLifeCycleRequest) {
  return backendClient.POST('/apis/{apiSlug}/life-cycle', {
    params: {
      path: {
        apiSlug,
      },
    },
    body: request,
  });
}

export function updateApiFields(apiSlug: string, request: ApiUpdateRequest) {
  return backendClient.PATCH('/apis/{apiSlug}', {
    params: {
      path: {
        apiSlug,
      },
    },
    body: request,
  });
}

export function createScopeCreationRequest(apiSlug: string, request: ScopeCreationRequest) {
  return backendClient.POST('/apis/{apiSlug}/scope-creation-requests', {
    params: {
      path: {
        apiSlug,
      },
    },
    body: request,
  });
}

export function deletePendingScopeCreationRequest(apiSlug: string, scopeCreationRequestId: string) {
  return backendClient.DELETE('/apis/{apiSlug}/scope-creation-requests/{scopeCreationRequestId}', {
    params: {
      path: {
        apiSlug,
        scopeCreationRequestId,
      },
    },
  });
}

export function createScopeDeletionRequest(apiSlug: string, request: ScopeDeletionRequest) {
  return backendClient.POST('/apis/{apiSlug}/scope-deletion-requests', {
    params: {
      path: {
        apiSlug,
      },
    },
    body: request,
  });
}

export function deletePendingScopeDeletionRequest(apiSlug: string, scopeDeletionRequestId: string) {
  return backendClient.DELETE('/apis/{apiSlug}/scope-deletion-requests/{scopeDeletionRequestId}', {
    params: {
      path: {
        apiSlug,
        scopeDeletionRequestId,
      },
    },
  });
}
